<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Type of Operation &nbsp;
          <save-button @click="save"></save-button>
          <small v-if="isSaving">Saving...</small>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Safety Management</li>
          <li class="breadcrumb-item">Type of Operation</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchKeyword"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="ExportValueLists.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="value_lists_excel"
                    :fields="excel_fields"
                    worksheet="Type of operation"
                    name="Type of operation.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Name</th>
                    <th>Is Active</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <loading-table
                    :isLoading="isLoading"
                    cols="12"
                  ></loading-table>
                  <tr v-if="valueLists.length == 0">
                    <td colspan="12" class="text-center">No data Found</td>
                  </tr>
                  <tr
                    v-for="(valueList, ar) in valueLists"
                    :key="`valueList${ar}`"
                  >
                    <td>{{ ar + 1 }}.</td>
                    <td>
                      <input
                        v-uppercase
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        v-model="valueList.name"
                      />
                    </td>
                    <td>
                      <div class="form-check form-switch mb-2">
                        <input
                          type="checkbox"
                          v-model="valueList.is_active"
                          class="form-check-input"
                          id="formSwitch1"
                        />
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <button
                          class="btn btn-danger btn-sm"
                          @click="deleteValueList(valueList)"
                          v-if="!valueList.id"
                        >
                          Delete
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(valueList.id)"
                          v-else
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="value_id">
                    <td
                      colspan="12"
                      align="center"
                      style="
                        background-color: #6571ff;
                        color: white;
                        border-radius: 10px;
                        box-shadow: none;
                      "
                      @click="addEmptyValueList()"
                    >
                      Add New Row
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "Values",
  data() {
    return {
      value_id: "",
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isSaving: false,
      isExcelloading: false,
      searchKeyword: "",
      valueLists: [],
      value_lists_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        NAME: "name",
        "IS ACTIVE": "is_active",
      },
      ExportValueLists: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // Get Data
    async getData(page = 1) {
      this.ExportValueLists = [];
      this.isLoading = true;
      let masters = await axios.get("value_lists/masters");
      masters = masters.data;
      masters.values.forEach((value) => {
        if (
          value.name == "Type of operation" &&
          value.category == "Safety Management"
        ) {
          let value_id = value.id;
          this.value_id = value_id;
        }
      });

      let valueLists = await axios.get(`/values/${this.value_id}/value_lists`);
      this.valueLists = valueLists.data.data;
      this.count = valueLists.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    // Adding an Emplty Row
    addEmptyValueList() {
      this.valueLists.push({
        value_id: this.value_id,
        company_id: this.company.id,
        created_by_id: this.user.id,
        name: "",
        code: "",
        is_active: 1,
      });
    },
    // Delete an Empty Row
    deleteValueList(valueList) {
      this.valueLists = this.valueLists.filter((ar) => ar != valueList);
    },
    // Save
    async save() {
      if (this.valueLists.length > 0) {
        this.isSaving = true;
        let payload = {
          datas: this.valueLists,
        };
        let response = await axios.post(
          `/values/${this.value_id}/value_lists_multiple`,
          payload
        );
        this.valueLists = response.data.data;
        this.isSaving = false;
      }
      this.clearData();
    },
    // Search
    async search() {
      this.isLoading = true;
      let page = 1;
      let columns = ["name"];

      let valueLists = await axios.get(
        `/searchData?table_name=value_lists&columns=${columns}&searchKeyword=${this.searchKeyword}&value=${this.value_id}&page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.valueLists = valueLists.data.data;
      this.count = valueLists.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
      this.clearData();
    },
    // Delete from DB
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=value_lists`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
    // Clear Data for latest Filter Excel Generation
    clearData() {
      this.ExportValueLists = [];
      console.log("Cleared Data");
    },
    // Export to Excel
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Type of operation";
      this.value_lists_excel = [];
      let ExportValueLists = [];
      let columns = ["name"];
      ExportValueLists = await axios.get(
        `/searchData?table_name=value_lists&columns=${columns}&searchKeyword=${this.searchKeyword}&value=${this.value_id}`
        // `/values/${this.value_id}/value_lists`
      );
      this.ExportValueLists = ExportValueLists.data.data;
      let sr_no = 1;
      this.ExportValueLists.forEach((valuelist) => {
        this.value_lists_excel.push({
          sr_no: sr_no,
          name: valuelist.name,
          is_active: valuelist.is_active ? "YES" : "NO",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
  },
};
</script>
